import React from 'react';
import { motion } from 'framer-motion';
import { BookHeartIcon, CompassIcon, HistoryIcon, MapPinIcon, SearchIcon, TelescopeIcon } from 'lucide-react';
export function Audience() {
  const people = [['Amantes de la historia', HistoryIcon], ['Aficionados a la arqueología', SearchIcon], ['Seguidores de documentales', TelescopeIcon], ['Personas curiosas', CompassIcon], ['Viajeros culturales', MapPinIcon], ['Lectores apasionados', BookHeartIcon]];
  return <section className="bg-dark-card/45 px-5 py-24 md:py-32" data-id="element-21">
      <div className="mx-auto max-w-7xl" data-id="element-22">
        <div className="mb-14 max-w-2xl" data-id="element-23">
          <p className="text-xs font-bold uppercase tracking-[.22em] text-gold" data-id="element-24">
            Para exploradores
          </p>
          <h2 className="mt-3 text-4xl font-semibold text-stone-light md:text-6xl" data-id="element-25">
            ¿Para quién es esta colección?
          </h2>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26">
          {people.map(([label, Icon], index) => <motion.div key={label as string} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-4 rounded-xl border border-dark-border bg-dark p-6" data-id="element-27">
              <Icon className="h-5 w-5 text-gold-light" data-id="element-28" />
              <span className="text-stone-light" data-id="element-29">{label}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}